import queryString from 'query-string';

export function getPage() {
  const { p } = getURLQueryParams();
  return !!p ? parseInt(p, 10) : 1;
}

export function setPage(page) {
  setURLParams([{ key: 'p', value: page }]);
}

export function getURLQueryParams() {
  const paramString = queryString.extract(window.location.hash);
  return queryString.parse(paramString);
}

export function setURLParams(newParams) {
  const params = getURLQueryParams();
  for (var i = 0; i < newParams.length; i++) {
    const { key, value } = newParams[i];
    params[key] = value;
    if (!value) {
      delete params[key];
    }
  }

  const queryParams = queryString.stringify(params);

  if (queryParams.length > 0) {
    window.location.href = `#/?${queryParams}`;
  } else {
    window.location.href = ``;
  }
}
